<template>
    <div>
        <span v-for="(link, index) in Breadcrumbs" :key="link.to">
            <router-link v-if="index < Breadcrumbs.length-1" :to="link.to">{{link.text}}</router-link>
            <span v-else :key="link.text">{{link.text}}</span>
            <span v-if="index < Breadcrumbs.length-1" :key="index">&nbsp;>&nbsp;</span>
        </span>
    </div>
</template>

<script>

    class ResolveContext {
        constructor(nextNodeHandler, route, i18n) {
            this.nextNode = (nodeName) => nextNodeHandler(nodeName, this);
            this.route = route;
            this.i18n = i18n;
            this.resolvedNodes = [];
        }
    }


    export default {
        name: 'breadcrumbs',
        data() {
            return {
                resolvedNodes:[]
            }
        },
        watch: {
            async $route(to, from) {
                await this.resolveBreadcrumb(to);
                //let title = await this.$router.currentRoute.getTitle();
                //window.document.title = title;
            }
        },
        methods: {
            async processNode(node, context) {
                if (!node.meta) {
                    context.resolvedNodes.push({ text: 'Missing "meta"', to: node.path });
                }
                else {
                    if (node.meta.resolve) {
                        await node.meta.resolve(context);
                    } else if (!node.meta.breadcrumb) {
                        context.resolvedNodes.push({ text: 'Missing "meta.breadcrumb"', to: node.path });
                    } else {
                        const nodeText = context.i18n.t(node.meta.breadcrumb);
                        context.resolvedNodes.push({ text: nodeText, to: node.path });
                        if (node.meta.parentName) {
                            await this.processNodeByName(node.meta.parentName, context);
                        }
                    }
                }
            },
            async processNodeByName(routeName, context) {
                let node = this.$router.options.routes.find(x => x.name === routeName);
                await this.processNode(node, context);
            },
            async resolveBreadcrumb(route) {
                const context = new ResolveContext(this.processNodeByName, this.$route, this.$i18n);
                await this.processNode(route, context);
                this.resolvedNodes = context.resolvedNodes;
            }
        },
        computed: {
            Breadcrumbs() {
                return this.resolvedNodes.reverse();
            }
        },
        async mounted() {
            await this.resolveBreadcrumb(this.$router.currentRoute);
        }
    }
</script>

<style scoped>
    .router-link-active {
        color: #41B883;
    }

</style>